import { forwardRef, useState } from "react"

function PostImage({ src, fallbackSrc = "/avatar.svg", alt = "" }, ref) {
  const [hasError, setHasError] = useState(false);

  const handleError = (e) => {
    setHasError(true);
    e.target.src = fallbackSrc;
  };

  return (
    <>
      {
        !hasError &&
        <img
          ref={ref}
          className="object-cover w-14 h-14 rounded"
          onError={handleError}
          alt={alt}
          src={src || fallbackSrc
          }
        />
      }
      {
        hasError &&
        <svg className="w-14 h-14 rounded" viewBox="0 0 16 16" id="meteor-icon-kit__solid-image-s" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 12.4142V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V8.4142C14 8.149 13.8946 7.8946 13.7071 7.7071L12.7071 6.7071C12.3166 6.3166 11.6834 6.3166 11.2929 6.7071L8.7071 9.2929C8.3166 9.6834 7.6834 9.6834 7.2929 9.2929L6.7071 8.7071C6.3166 8.3166 5.68342 8.3166 5.29289 8.7071L2.29289 11.7071C2.10536 11.8946 2 12.149 2 12.4142zM4.5 6C5.32843 6 6 5.32843 6 4.5C6 3.67157 5.32843 3 4.5 3C3.67157 3 3 3.67157 3 4.5C3 5.32843 3.67157 6 4.5 6zM3 0H13C14.6569 0 16 1.34315 16 3V13C16 14.6569 14.6569 16 13 16H3C1.34315 16 0 14.6569 0 13V3C0 1.34315 1.34315 0 3 0z" fill="#1C274C"></path></g></svg>
      }
    </>
  );
}

export default forwardRef(PostImage)